import React from "react";
import Spinner from "react-bootstrap/Spinner";

const Loader = () => {
	return (
		<div className="fixed-top w-100 vh-100 bg-white d-flex align-items-center justify-content-center">
			<Spinner animation="border" />
		</div>
	);
};

export default Loader;
